const state = {
  // Styles of chat container
  // New styles should place here
  style: {
    width: '',
    height: ''
  },

  // Show time of message
  showMessageTime: false,

  // Username color (black)
  usernameColor: {
    hex: '#000000',
    hsl: {
      h: 0,
      s: 0,
      l: 0,
      a: 1
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0,
      a: 1
    },
    rgba: {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    },
    a: 1
  },

  // Palette for username
  palette: [
    '#4D4D4D', '#999999', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00',
    '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#808080',
    '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5',
    '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3',
    '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D',
    '#0062B1', '#653294', '#AB149E'
  ],

  // Color of username link text
  usernameLinkTextColor: '#FFFFFF',

  // Color of username link background
  usernameLinkBackground: '#FFA500'
}

const getters = {
  style: state => state.style,
  showMessageTime: state => state.showMessageTime,
  usernameColor: state => state.usernameColor,
  palette: state => state.palette,
  usernameLinkTextColor: state => state.usernameLinkTextColor,
  usernameLinkBackground: state => state.usernameLinkBackground
}

const actions = { }

const mutations = {
  setStyle (state, { height, width }) {
    state.style.height = height
    state.style.width = width
  },

  setUsernameColor (state, { color }) {
    state.usernameColor = color
  },

  setShowMessageTime (state, { showMessageTime }) {
    state.showMessageTime = showMessageTime
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/styles.js